import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "auctions-content" }
const _hoisted_2 = { key: 1 }

import { ref, watch, computed, PropType } from 'vue';

import BannerImage from '@/components/elements/BannerImage.vue';
import BannerHeadline from '@/components/elements/BannerHeadline.vue';
import LanguageSelector from '@/components/elements/LanguageSelector.vue';
import VideoPlayer from './VideoPlayer.vue';
import TranslatedContent from '../elements/TranslatedContent.vue';
import { Auction } from '@/types/metadata';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuctionsContent',
  props: {
  activeTab: {
    type: Number,
    required: true
  },
  lang: {
    type: String,
    required: true
  },
  hasStarted: {
    type: Boolean,
    required: true
  },
  isLoading: {
    type: Boolean,
    required: true
  },
  fetchingVideo: {
    type: Boolean,
    required: true
  },
  auctions: {
    type: Array as PropType<Auction[]>,
    required: true
  }
},
  emits: ['update:lang'],
  setup(__props, { emit }) {

const props = __props;





const langRef = ref(props.lang);
watch(langRef, () => {
  console.log('update:lang', langRef.value)
  emit('update:lang', langRef.value);
});

const auction = computed(() => {
  return props.auctions[props.activeTab - 1];
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BannerImage, {
      bannerUrl: auction.value.bannerUrl,
      activeTab: __props.activeTab
    }, {
      default: _withCtx(() => [
        _createVNode(BannerHeadline, {
          logoUrl: auction.value.logoUrl
        }, {
          "language-selector": _withCtx(() => [
            _createVNode(LanguageSelector, {
              modelValue: langRef.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((langRef).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          "video-player": _withCtx(() => [
            (!!auction.value.streamKey)
              ? (_openBlock(), _createBlock(VideoPlayer, {
                  key: 0,
                  "data-stream-key": auction.value.streamKey
                }, null, 8, ["data-stream-key"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2))
          ]),
          "translated-content": _withCtx(() => [
            _createVNode(TranslatedContent, {
              lang: __props.lang,
              title: auction.value.headline,
              contactInfo: auction.value.contactInfo
            }, null, 8, ["lang", "title", "contactInfo"])
          ]),
          _: 1
        }, 8, ["logoUrl"])
      ]),
      _: 1
    }, 8, ["bannerUrl", "activeTab"])
  ]))
}
}

})